// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__6VjwY","divider-horizontal":"Divider_divider-horizontal__Ve55X"};